module.exports = __webpack_public_path__ + "img/logoGalaposBranco.36816306.svg";